import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { capitalizeFirstLetter, getDisplayName } from "../utils/tools";
import styles from "../styles/Model.module.css";
import { Heart } from "react-iconly";
import { TbChartCircles, TbLetterCaseToggle } from "react-icons/tb";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@jammable/ui-components/Accordion";
import { toast } from "react-hot-toast";
import { getAuth } from "firebase/auth";
import { NextSeo } from "next-seo";
import Link from "next/link";
import { auth } from "../utils/firebaseAdmin";
import millify from "millify";
import { useModal } from "../context/ModalContext";
import { useAuth } from "../context/AuthProvider";
// import EditModelModal from "../components/modals/EditModelModal";
import useAuthModal from "../hooks/useAuthModal";
import { useTranslation } from "next-i18next";
import { AiFillLock } from "react-icons/ai";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
// import DeleteModelModal from "../components/modals/DeleteModelModal";
// import ReportModal from "../components/modals/ReportModal";
// import AddToCollectionModal from "../components/collection/modals/AddToCollectionModal";
import Model from "../models/Model";
import RateVoiceModal from "@/components/modals/RateVoiceModal";
import { IoIosMicrophone, IoIosRemoveCircle } from "react-icons/io";
import {
  FaComment,
  FaMusic,
  FaPlus,
  FaSearch,
  FaShare,
  FaStar,
  FaTrash,
} from "react-icons/fa";
import TryVoiceSection from "../components/TryVoiceSection";
import { useQuery } from "react-query";
import { ModelGrid } from "@jammable/ui-components/ModelGrid";
import CreateTTSFlow from "../components/conversion/CreateTTSFlow";
import MicrophoneConversionFlow from "../components/conversion/MicrophoneConversionFlow";

import ModelCommentSection from "../components/ModelCommentSection";
import UpgradeModal from "../components/modals/UpgradeModal";
import ConversionPageActionFlowMobile from "../components/conversion/ConversionPageActionFlowMobile";
import { BsCollectionFill, BsThreeDots } from "react-icons/bs";
import { DropdownMenuItem } from "@jammable/ui-components/DropdownMenu";
import { MdEdit, MdThumbsUpDown, MdUpdate } from "react-icons/md";
import { Spinner } from "@jammable/ui-components/Loader";
import { Button, SecondaryButton } from "@jammable/ui-core";
import Dropdown from "../components/dropdown/Dropdown";
import VoiceImage from "@/components/VoiceImage";
import CreateConversion from "../components/conversionv2/CreateConversion";
import connectToDb from "@/utils/mongodb";
// import CreateCollectionModal from "@/components/collection/modals/CreateCollectionModal";
import ModelTopUsersSection from "@/components/ModelTopUsersSection";
import dynamic from "next/dynamic";
import { MODEL_PROJECTION } from "./api/model";
import { IoArrowForward } from "react-icons/io5";
import LibraryDemosSection from "@/components/LibraryDemosSection";
import Image from "next/image";
const EditModelModal = dynamic(
  () => import("../components/modals/EditModelModal"),
);
const DeleteModelModal = dynamic(
  () => import("../components/modals/DeleteModelModal"),
);
const ReportModal = dynamic(() => import("../components/modals/ReportModal"));
const AddToCollectionModal = dynamic(
  () => import("../components/collection/modals/AddToCollectionModal"),
);
const CreateCollectionModal = dynamic(
  () => import("@/components/collection/modals/CreateCollectionModal"),
);

const ModelCollectionsWithVoice = dynamic(
  () => import("@/components/ModelCollectionsWithVoice"),
);

const ModelPage = ({ modelData, clientIp, isPrivate, isRemoved, token }) => {
  dayjs.extend(relativeTime);

  const { user } = useAuth();
  const { checkAuthAndExecute } = useAuthModal();

  const [isLiked, setIsLiked] = useState(modelData?.isLiked);
  const [likes, setLikes] = useState(modelData?.likes ? modelData?.likes : 0);
  const [country, setCountry] = useState(null);

  // sdad
  const { openModal, closeModal } = useModal();
  const { t } = useTranslation();

  // awdadawd
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  const [tab, setTab] = useState("cover");

  const title = `${modelData?.artistname} AI Voice Generator | Jammable AI Covers`;
  const description = `${modelData?.artistname} AI voice & song generator. Create ${modelData?.artistname} AI voice covers with advanced AI voice technology and 50,000+ AI voices.`;
  const url = `https://www.jammable.com/${modelData?.urlParam}`;

  const fetchCountry = async () => {
    try {
      const response = await fetch(
        `http://www.geoplugin.net/json.gp?ip=${clientIp}`,
      );
      const data = await response.json();
      const country = data?.geoplugin_countryName?.toLowerCase();
      setCountry(country);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    try {
      fetchCountry();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const likeModel = async () => {
    if (!checkAuthAndExecute()) return false;
    if (isLiked) {
      setLikes(likes - 1);
    } else {
      setLikes(likes + 1);
    }
    setIsLiked(!isLiked);
    const auth = getAuth();
    const token = await auth?.currentUser?.getIdToken();
    if (!token) {
      return;
    }
    axios
      .post(
        `/api/user/likeModel`,
        { modelId: modelData?._id },
        { headers: { Authorization: token } },
      )
      .then((res) => {
        toast.success(res?.data.message);
      })
      .catch((err) => {
        toast.success("Something went wrong. Please try again");
      });
  };

  const badges = [...(modelData?.badges ?? [])].slice(0, 3);
  const similarVoiceData = useQuery(
    ["similar-voices", modelData?._id],
    async () => {
      const { data } = await axios.get(`/api/model/getDuetMatches`, {
        params: {
          modelIds: modelData?._id,
          limit: 4,
        },
      });
      return data;
    },
    {
      enabled: modelData?._id ? true : false,
    },
  );

  const collections = useQuery(["collections", modelData?._id], async () => {
    const { data } = await axios.get(`/api/model/getCollections`, {
      params: {
        modelId: modelData?._id,
      },
    });
    return data;
  });

  const { data: downloadReliability } = useQuery(
    ["download-reliability"],
    async () => {
      const { data } = await axios.get(`/api/other/getDownloadReliability`);
      return data;
    },
  );

  const iconStyle = `md:tw-min-w-16 md:tw-min-h-16 tw-min-w-14 tw-min-h-14 tw-h-14 tw-w-14 tw-overflow-hidden tw-relative tw-rounded-2xl md:tw-rounded-full`;

  const commentSectionRef = useRef(null);
  const scrollToComments = () => {
    if (commentSectionRef.current) {
      const yOffset = -130; // Adjust this value as needed
      const element = commentSectionRef.current;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const librarySongDemoSuccessCount = modelData?.librarySongDemos?.filter(
    (demo) => demo.status === "processed",
  )?.length;

  return isRemoved ? (
    <div style={{ height: "100vh" }} className="container-center">
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          title: title,
          description: description,
          url: url,

          images: [
            {
              url: modelData?.image?.url,
              width: 900,
              height: 900,
              alt: "Jammable Model",
            },
          ],
        }}
      />
      <div
        style={{
          color: "black",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
        className={`main ${styles["model-page-fade"]}`}
      >
        <IoIosRemoveCircle size={100} />
        <div className="tw-text-center tw-text-3xl tw-py-2 tw-font-black tw-tracking-tight">
          This voice has been removed.
        </div>
        <Button
          as={Link}
          href={`/models`}
          className="tw-rounded-full tw-mt-2"
          flat
        >
          Browse Other Voices
        </Button>
      </div>
    </div>
  ) : isPrivate ? (
    <div style={{ height: "100vh" }} className="container-center">
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          title: title,
          description: description,
          url: url,

          images: [
            {
              url: modelData?.image?.url,
              width: 900,
              height: 900,
              alt: "Jammable Model",
            },
          ],
        }}
      />
      <div
        style={{
          color: "black",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
        className={`main ${styles["model-page-fade"]}`}
      >
        <AiFillLock size={100} />
        <div className="tw-text-center tw-text-3xl tw-py-2 tw-font-black tw-tracking-tight">
          This voice is private.
        </div>
        <div className="tw-flex tw-gap-2">
          <Button
            as={Link}
            href={`/models`}
            className="tw-rounded-full tw-mt-1"
          >
            Browse other Voices
          </Button>
          <SecondaryButton
            as={Link}
            href={`/login`}
            className="tw-rounded-full tw-mt-1"
          >
            Sign In
          </SecondaryButton>
        </div>
      </div>
    </div>
  ) : (
    <div className={`container ${styles.container}`}>
      <UpgradeModal
        open={upgradeModalOpen}
        setOpen={setUpgradeModalOpen}
        from="model-page"
      />

      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          title: title,
          description: description,
          url: url,

          images: [
            {
              url: modelData?.image?.url,
              width: 900,
              height: 900,
              alt: "Jammable Model",
            },
          ],
        }}
      />
      <div
        style={{
          height: tab === "community" && "max-content",
          marginTop: 30,
        }}
        className={`main ${styles["model-page-fade"]}`}
      >
        <div className={styles["model-page-mobile-container"]}>
          <VoiceImage
            model={modelData}
            fill
            quality={25}
            className={styles["model-page-mobile"]}
            priority={true}
          />
        </div>
        <div className="tw-w-full tw-px-2">
          {modelData?.newerVersion && (
            <Link
              href={`/${modelData?.newerVersion?.urlParam}`}
              className="tw-fixed md:tw-relative tw-z-20 tw-top-[40px] md:tw-top-0 tw-left-0 tw-right-0 md:tw-mb-6 tw-mx-2 md:tw-mx-0 tw-flex tw-items-center tw-justify-between tw-bg-purple-50 hover:tw-bg-purple-100 tw-transition-all   tw-p-3 md:tw-p-4 tw-rounded-xl md:tw-rounded-2xl"
            >
              <div className="tw-flex tw-items-center tw-gap-2 md:tw-gap-4">
                <div className="tw-flex tw-items-center tw-justify-center tw-relative">
                  <div className="tw-absolute tw--top-0.5 md:tw--top-1 tw--right-0.5 md:tw--right-1 tw-bg-green-400 tw-w-2 md:tw-w-3 tw-h-2 md:tw-h-3 tw-rounded-full tw-border-2 tw-border-white" />

                  <VoiceImage
                    model={modelData?.newerVersion}
                    size={40}
                    className="tw-rounded-lg md:tw-rounded-xl tw-shadow-lg"
                  />
                </div>
                <div className="tw-flex tw-flex-col">
                  <div className="tw-text-xs md:tw-text-sm tw-font-black tw-text-purple-700">
                    Newer Version Available!
                  </div>
                  <div className="tw-text-[10px] md:tw-text-xs tw-text-purple-600">
                    {modelData?.username} has updated their voice. Click to try
                    the latest version.
                  </div>
                </div>
              </div>
              <div className="tw-flex tw-items-center tw-gap-1 md:tw-gap-2">
                <IoArrowForward
                  className="tw-text-purple-700"
                  strokeWidth={4}
                  size={24}
                />
              </div>
            </Link>
          )}
          <div className="tw-flex tw-justify-between tw-gap-2 tw-w-full tw-p-0">
            <div className="tw-flex tw-gap-6 tw-w-full tw-relative">
              <div className="tw-hidden tw-relative md:tw-flex tw-w-max">
                <VoiceImage
                  model={modelData}
                  size={200}
                  quality={75}
                  className={`tw-hidden md:tw-flex tw-rounded-3xl`}
                  priority={true}
                />
              </div>
              <div className="tw-h-full tw-flex tw-flex-col md:tw-mt-0 tw--mt-28 tw-z-10 tw-w-full">
                <div className="md:tw-hidden  tw-flex tw-flex-wrap tw-gap-2 tw-mb-4">
                  {modelData?.isCommunityFavorite && (
                    <div className=" tw-flex md:tw-hidden tw-items-center tw-justify-center tw-gap-1 tw-bg-gradient-to-r tw-from-amber-300/80 tw-to-amber-400 tw-text-black tw-px-2 tw-py-1 tw-rounded-2xl tw-text-xs tw-text-center tw-font-black ">
                      <FaStar
                        size={16}
                        className="tw-text-black tw-z-10 tw--mt-1"
                      />
                      COMMUNITY FAVORITE
                    </div>
                  )}
                  {badges?.map((badge) => {
                    return (
                      <Link
                        key={badge}
                        href={{ pathname: `/models`, query: { filter: badge } }}
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        className="tw-p-1 tw-text-nowrap tw-px-2 tw-text-sm tw-flex tw-items-center tw-gap-1 tw-font-bold tw-bg-purple-500/20 hover:tw-bg-purple-200 tw-border tw-rounded-3xl "
                      >
                        <FaSearch className="tw-text-purple-800 " size={15} />
                        <span className="tw-text-purple-800  ">
                          {capitalizeFirstLetter(badge.trim())}
                        </span>
                      </Link>
                    );
                  })}
                </div>
                <div>
                  {modelData?.accessIds.length > 0 ? (
                    <Link
                      href={`/@${modelData?.username}`}
                      className="tw-text-lg tw-font-bold tw-overflow-visible tw-flex tw-items-center tw-gap-2 tw-text-sm"
                    >
                      <div className=" tw-bg-gray-200/60 hover:tw-bg-gray-200 tw-transition-all  tw-flex tw-items-center tw-gap-1 tw-w-max tw-text-sm tw-text-purple-700 tw-p-1 tw-px-1 tw-pr-2 tw-rounded-full">
                        {/* <FaUser size={14} /> */}
                        <Image
                          src={modelData?.avatar}
                          width={20}
                          height={20}
                          alt={modelData?.username}
                          className="tw-rounded-full"
                        />
                        {modelData?.username}
                      </div>{" "}
                      <span className="tw-text-black/50">
                        {dayjs(modelData?.createdAt).fromNow()}
                      </span>
                    </Link>
                  ) : (
                    <div className="tw-text-lg tw-font-bold tw-opacity-60 md:tw-opacity-40">
                      Uploaded By{" "}
                      <span className="">{modelData?.username}</span> ·{" "}
                      <span>{dayjs(modelData?.createdAt).fromNow()}</span>
                    </div>
                  )}
                </div>
                <h1 className="tw-text-4xl md:tw-text-5xl tw-mb-0 tw-font-black tw-mt-2 tw-tracking-tight md:tw-truncate">
                  {getDisplayName(modelData)}
                </h1>
                <div className="tw-hidden  md:tw-flex tw-gap-2 tw-mt-4">
                  {modelData?.collection &&
                    modelData?.collection?.modelsCount > 2 && (
                      <Link
                        href={`/collection/${modelData?.collection?._id}`}
                        className="tw-text-xs tw-bg-gray-100 tw-transition-bg tw-rounded-full tw-font-bold tw-text-sm tw-flex tw-items-center tw-gap-2 tw-p-1 tw-pr-2  tw-w-max hover:tw-bg-gray-200"
                      >
                        <div className="tw-flex tw-items-center tw-justify-center ">
                          <VoiceImage
                            model={{ image: modelData?.collection?.image }}
                            size={20}
                            className="tw-rounded-xl tw-brightness-75"
                          />
                          <BsCollectionFill
                            size={8}
                            className="tw-absolute tw-white tw-text-white"
                          />
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-0">
                          {/* <span>{modelData?.collection?.title}</span> */}
                          <span>
                            {modelData?.collection?.modelsCount} Voices
                          </span>
                        </div>
                      </Link>
                    )}
                  {modelData?.isCommunityFavorite && (
                    <div className="md:tw-flex tw-hidden tw-items-center tw-justify-center tw-gap-1 tw-bg-gradient-to-r tw-from-amber-300/80 tw-to-amber-400 tw-text-black tw-px-2 tw-py-1 tw-rounded-2xl tw-text-xs tw-text-center tw-font-black ">
                      <FaStar
                        size={16}
                        className="tw-text-black tw-z-10 tw--mt-1"
                      />
                      COMMUNITY FAVORITE
                    </div>
                  )}
                  {badges?.map((badge) => {
                    return (
                      <Link
                        key={badge}
                        href={{ pathname: `/models`, query: { filter: badge } }}
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        className="tw-p-1 tw-text-nowrap tw-px-2 tw-text-sm tw-flex tw-items-center tw-gap-1 tw-font-bold tw-bg-purple-100 hover:tw-bg-purple-200 tw-transition-bg tw-border tw-rounded-3xl "
                      >
                        <FaSearch className="tw-text-purple-700 " size={15} />
                        <span className="tw-text-purple-700  ">
                          {capitalizeFirstLetter(badge.trim())}
                        </span>
                      </Link>
                    );
                  })}
                </div>
                <div className="tw-mt-4 md:tw-mt-auto  tw-flex tw-items-center tw-gap-2">
                  <div
                    className={`tw-flex tw-flex-col tw-ml-1 tw-text-sm tw-items-center tw-font-bold tw-bg-gray-00  tw-text-gray-500 tw-mr-2`}
                  >
                    <span className="tw-text-lg tw--mb-1 tw-font-black">
                      {millify(modelData?.uses)}
                    </span>
                    <span className="tw-font-black">Uses</span>
                  </div>

                  <div
                    onClick={async () => {
                      likeModel();
                    }}
                    className={`tw-flex tw-cursor-pointer tw-text-sm tw-p-2 tw-h-max tw-px-3 tw-rounded-3xl tw-transition-bg tw-items-center tw-gap-2 tw-font-bold ${isLiked ? "tw-bg-purple-100  tw-text-purple-700" : "tw-bg-gray-100 hover:tw-bg-gray-200  tw-text-gray-500"} tw-w-max`}
                  >
                    <Heart
                      size={21}
                      set={isLiked ? "bold" : "bold"}
                      className={`${isLiked ? "tw-purple-700" : "tw-gray-300"}`}
                    />
                    {likes}
                  </div>
                  <div
                    onClick={scrollToComments}
                    className={`tw-flex tw-cursor-pointer tw-text-sm tw-p-2 tw-px-3 tw-rounded-3xl tw-items-center tw-gap-2 tw-font-bold tw-bg-gray-100 hover:tw-bg-gray-200 tw-transition-bg tw-text-gray-500 tw-w-max`}
                  >
                    <FaComment
                      size={21}
                      set={isLiked ? "bold" : "bold"}
                      className={`${isLiked ? "tw-purple-700" : "tw-gray-300"}`}
                    />
                    {modelData?.comments ?? 0}
                  </div>

                  <div
                    onClick={() => {
                      if (!checkAuthAndExecute()) return false;
                      openModal(
                        "add-to-collection-modal",
                        <AddToCollectionModal
                          model={modelData}
                          reroute={true}
                          closeModal={() =>
                            closeModal("add-to-collection-modal")
                          }
                          openCreate={() => {
                            closeModal("add-to-collection-modal");

                            setTimeout(() => {
                              openModal(
                                "create-collection-modal",
                                <CreateCollectionModal />,
                              );
                            }, 100);
                          }}
                        />,
                      );
                    }}
                    className="tw-bg-gray-100 hover:tw-bg-gray-200 tw-transition-bg tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-p-3 tw-text-gray-500"
                  >
                    <FaPlus className="tw-z-10" />
                  </div>

                  <div
                    onClick={() => {
                      openModal(
                        "rate-voice-modal",
                        <RateVoiceModal model={modelData} />,
                      );
                    }}
                    className="tw-bg-gray-100 hover:tw-bg-gray-200 tw-transition-bg tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-p-3 tw-text-gray-500"
                  >
                    <MdThumbsUpDown size={16} />
                  </div>

                  <Dropdown
                    dropdownItems={
                      <>
                        <DropdownMenuItem
                          onClick={async () => {
                            const textToCopy = `https://www.jammable.com/${modelData?.urlParam}`;
                            navigator.clipboard.writeText(textToCopy);
                            toast.success("Copied to clipboard!");
                          }}
                          className="tw-p-2 tw-pl-3 tw-gap-2 tw-bg-gray-100 hover:tw-bg-gray-200 tw-font-bold tw-cursor-pointer tw-rounded-3xl"
                        >
                          <FaShare />
                          Share Voice
                        </DropdownMenuItem>
                        {modelData?.accessIds.includes(user?.firebaseUid) && (
                          <DropdownMenuItem
                            onClick={() => {
                              openModal(
                                "edit-model-modal",
                                <EditModelModal
                                  model={modelData}
                                  reroute={true}
                                />,
                              );
                            }}
                            className="tw-p-2 tw-pl-3 tw-gap-2 tw-bg-gray-100 hover:tw-bg-gray-200 tw-font-bold tw-cursor-pointer tw-rounded-3xl"
                          >
                            <MdEdit />
                            Edit Voice
                          </DropdownMenuItem>
                        )}

                        {!modelData?.accessIds.includes(user?.firebaseUid) && (
                          <DropdownMenuItem
                            onClick={() => {
                              if (!checkAuthAndExecute()) return false;
                              openModal(
                                "report-modal",
                                <ReportModal
                                  item={modelData}
                                  type="voice"
                                  closeModal={() => closeModal("report-modal")}
                                />,
                              );
                            }}
                            className="tw-p-2 tw-text-red-500 tw-pl-3 tw-flex tw-items-center  tw-gap-2 tw-bg-red-100 hover:tw-bg-red-200 tw-font-bold tw-cursor-pointer tw-rounded-3xl"
                          >
                            <FaTrash />
                            <span>Report Voice</span>
                          </DropdownMenuItem>
                        )}
                        {modelData?.accessIds.includes(user?.firebaseUid) && (
                          <DropdownMenuItem
                            onClick={() => {
                              openModal(
                                "delete-conversion-modal",
                                <DeleteModelModal
                                  model={modelData}
                                  closeModal={() =>
                                    closeModal("delete-model-modal")
                                  }
                                />,
                              );
                            }}
                            className="tw-p-2 tw-text-red-500 tw-pl-3 tw-flex tw-items-center  tw-gap-2 tw-bg-red-100 hover:tw-bg-red-200 tw-font-bold tw-cursor-pointer tw-rounded-3xl"
                          >
                            <FaTrash />
                            <span>Delete Voice</span>
                          </DropdownMenuItem>
                        )}
                      </>
                    }
                  >
                    <div className="tw-bg-gray-100 hover:tw-bg-gray-200 tw-transition-bg tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-p-2 tw-text-gray-500">
                      <BsThreeDots size={24} />
                    </div>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          {modelData?.description && (
            <div className="tw-font-black  tw-px-4 tw-w-full tw-text-pretty tw-relative tw-border-0 tw-bg-gray-50 tw-border-solid md:tw-w-max md:tw-max-w-full tw-flex tw-flex-col tw-mt-4 tw-text-lg  tw-p-3 tw-rounded-xl">
              <div className="tw-absolute tw-shadow-lg  tw-bg-purple-100 tw-rounded-xl tw--top-2 tw--right-2 tw-text-lg tw-w-10 tw-h-10 tw-text-center tw-flex tw-p-1 tw-items-center tw-justify-center">
                📣
              </div>{" "}
              <div className="tw-pr-6">Description</div>
              <div className="tw-font-semibold tw-text-base tw-text-wrap">
                {modelData?.description}
              </div>
            </div>
          )}
          <div
            style={{
              borderRadius: 20,
              boxShadow:
                "0px 10px 36px 0px rgba(120, 39, 200, 0.16), 0px 0px 0px 1px rgba(120, 39, 200, 0.06)",
            }}
            className={`${modelData?.description ? "tw-mt-3" : "tw-mt-8"} tw-grid tw-grid-cols-2 tw-flex-wrap  tw-gap-0`}
          >
            {[
              {
                name: "Choose Song",
                description: "Upload an audio file or link.",
                body: (
                  <CreateConversion
                    model={modelData}
                    ip={clientIp}
                    setUpgradeModalOpen={setUpgradeModalOpen}
                    downloadReliability={downloadReliability}
                  />
                ),
                icon: (
                  <div className={`${iconStyle} tw-bg-teal-300 `}>
                    <FaMusic
                      className="tw-text-purple-700 tw-absolute tw-left-5"
                      size={50}
                    />{" "}
                  </div>
                ),
              },
              {
                name: "Text To Speech",
                description: "Convert text to speech using this voice.",
                icon: (
                  <div
                    className={`${iconStyle} tw-bg-rose-400 tw-flex tw-items-center tw-justify-center `}
                  >
                    <TbLetterCaseToggle
                      className="tw-text-purple-700 tw-absolute tw-top-1"
                      size={50}
                    />{" "}
                  </div>
                ),
                body: (
                  <CreateTTSFlow
                    model={modelData}
                    ip={clientIp}
                    setUpgradeModalOpen={setUpgradeModalOpen}
                  />
                ),
              },
              {
                name: "Duet",
                description: "Create a duet with this voice.",
                icon: (
                  <div className={`${iconStyle} tw-bg-fuchsia-400`}>
                    <TbChartCircles
                      className="tw-text-purple-700 tw-absolute tw--bottom-7 tw--left-7"
                      size={100}
                    />
                  </div>
                ),
              },
              {
                name: "Microphone",
                description: "Convert using your voice.",
                isNew: true,
                icon: (
                  <div
                    className={`${iconStyle} tw-bg-blue-200  tw-items-center tw-justify-center tw-flex`}
                  >
                    <IoIosMicrophone
                      className="tw-text-purple-700 tw-absolute tw--bottom-2"
                      size={60}
                    />{" "}
                  </div>
                ),
                body: (
                  <MicrophoneConversionFlow
                    model={modelData}
                    ip={clientIp}
                    setUpgradeModalOpen={setUpgradeModalOpen}
                  />
                ),
              },
            ].map((item, idx) => {
              return (
                <ConversionPageActionFlowMobile
                  key={item.name}
                  item={item}
                  idx={idx}
                  model={modelData}
                />
              );
            })}
          </div>
          <div className="tw-mt-8 tw-flex tw-flex-col tw-gap-4 md:tw-flex-row">
            {librarySongDemoSuccessCount > 1000 ? (
              <LibraryDemosSection modelData={modelData} />
            ) : (
              <TryVoiceSection modelData={modelData} />
            )}
            {/* <ModelTopUsersSection modelData={modelData} /> */}
          </div>
          <div ref={commentSectionRef}>
            <ModelCommentSection user={user} model={modelData} token={token} />
          </div>

          {similarVoiceData?.isLoading && !similarVoiceData?.isError ? (
            <div className="tw-w-full tw-flex tw-items-center tw-justify-center tw-py-20">
              <Spinner size={5} className="tw-border-3" />
            </div>
          ) : similarVoiceData?.data?.models?.length === 0 ||
            similarVoiceData?.isError ? null : (
            <div className=" tw-flex tw-mt-14 tw-w-full tw-flex tw-flex-col">
              <div className="tw-font-bold tw-text-xl tw-w-full">
                Voices Like This{" "}
              </div>
              <div className="tw-font-semibold tw-mt-1 tw-opacity-40 tw-text-sm">
                Users commonly used these voices with {modelData?.artistname}.
              </div>
              <div className="tw-w-full tw-flex tw-gap-10 tw-mt-3 tw-items-center tw-justify-center">
                {similarVoiceData?.data?.models ? (
                  <ModelGrid items={similarVoiceData?.data?.models} />
                ) : (
                  <Spinner size={5} className="tw-border-3" />
                )}
              </div>
            </div>
          )}
          {collections?.data?.collections?.length > 0 && (
            <ModelCollectionsWithVoice
              collections={collections?.data?.collections}
            />
          )}
          <div className="tw-font-bold tw-text-xl tw-w-full tw-mb-3 tw-mt-16">
            Frequently Asked Questions{" "}
          </div>
          <Accordion
            type="single"
            collapsible
            className="tw-w-full tw-mt-8 tw-border tw-border-solid tw-rounded-3xl tw-p-2 tw-px-4"
          >
            <AccordionItem value="item-4">
              <AccordionTrigger>{`How do I make ${modelData?.artistname} AI covers?`}</AccordionTrigger>
              <AccordionContent>
                <div>
                  In order to make {modelData?.artistname} AI covers, you need
                  to either drop your original vocals/song into the box or use a
                  YouTube link (please read our{" "}
                  <Link
                    style={{
                      fontWeight: 600,
                      color: "#782dc8",
                      textDecoration: "underline",
                    }}
                    href="/dmca-policy"
                    target="_blank"
                  >
                    DMCA Policy
                  </Link>
                  ). Once you&apos;ve done so, press ready to convert! Your{" "}
                  {modelData?.artistname} AI cover will be ready in around 30-60
                  seconds.
                </div>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5">
              <AccordionTrigger>{`What input can I use for my ${modelData?.artistname} AI covers?`}</AccordionTrigger>
              <AccordionContent>
                <div>
                  You can only upload your original vocals/song. You should not
                  input any sound recordings that contain third party copyright
                  material without the owner&apos;s permission.
                </div>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6">
              <AccordionTrigger>{`How long will my ${modelData?.artistname} AI cover take?`}</AccordionTrigger>
              <AccordionContent>
                <div>
                  Your {modelData?.artistname} AI cover will be ready in around
                  30-60 seconds!
                </div>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-7">
              <AccordionTrigger>{`How many credits does each ${modelData?.artistname} AI cover use?`}</AccordionTrigger>
              <AccordionContent>
                <div>
                  Each {modelData?.artistname} AI cover will use just 1 credit!
                </div>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-8">
              <AccordionTrigger>
                Do I need to upload an acapella?
              </AccordionTrigger>
              <AccordionContent>
                <div>
                  No, you do not need to upload an acapella as our system will
                  extract the acapella regardless for your{" "}
                  {modelData?.artistname} AI cover!
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default ModelPage;

export async function getServerSideProps(context) {
  const { model } = context.query;
  const { req } = context;
  const token = context?.req?.cookies?.token;
  await connectToDb();

  const getClientIp = (req) => {
    const ip =
      (req.headers["x-forwarded-for"] || "").split(",").pop().trim() ||
      req.connection.remoteAddress ||
      req.socket.remoteAddress ||
      req.connection.socket.remoteAddress;
    return ip;
  };
  let firebaseUid;
  try {
    const decodedToken = await auth.verifyIdToken(token);
    firebaseUid = decodedToken.uid;
  } catch (error) {}

  const clientIp = getClientIp(req);
  const getModelData = async (urlParam) => {
    let pipeline = [
      {
        $match: { urlParam: urlParam },
      },
      {
        $lookup: {
          from: "collections",
          localField: "baseName",
          foreignField: "autoGeneratedId",
          as: "collection",
        },
      },
      {
        $unwind: {
          path: "$collection",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $lookup: {
          from: "models",
          localField: "newerVersion._id",
          foreignField: "_id",
          pipeline: [
            {
              $project: MODEL_PROJECTION,
            },
          ],
          as: "newerVersion",
        },
      },
      {
        $unwind: {
          path: "$newerVersion",
          preserveNullAndEmptyArrays: true,
        },
      },
      {
        $project: {
          ...MODEL_PROJECTION,
          isLiked: 1,
          baseName: 1,
          demos: 1,
          username: "$user.username",
          avatar: "$user.avatar",
          collection: 1,
        },
      },
    ];

    if (firebaseUid) {
      pipeline.splice(1, 0, {
        $addFields: {
          isLiked: {
            $in: [firebaseUid, { $ifNull: ["$likedBy", []] }],
          },
        },
      });
    }

    let model = await Model.aggregate(pipeline);
    return model[0];
  };
  try {
    const modelData = await getModelData(model);

    if (modelData?.training === true && process.env.NODE_ENV === "production") {
      return {
        redirect: { destination: "/models", permanent: false },
      };
    }
    if (modelData?.private) {
      if (!modelData?.accessIds.includes(firebaseUid)) {
        return {
          // redirect: { destination: "/models", permanent: false },
          props: {
            isPrivate: true,
            modelData: JSON.parse(JSON.stringify(modelData)),
          },
        };
      }
    }
    if (modelData?.isRemoved || modelData?.deleted) {
      return {
        props: {
          isRemoved: true,
          modelData: JSON.parse(JSON.stringify(modelData)),
        },
      };
    }
    return {
      props: {
        modelData: JSON.parse(JSON.stringify(modelData)),
        clientIp,
        token: token ?? null,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}
